import InjectAssets from "./inject-assets"
import deps from "./deps"
import DependencyResolver from "./dependency-resolver"

export default class {
  constructor(options) {
    const self = this

    if (typeof options !== "object") {
      throw 'Loader options type must be "Object".'
    }

    self.options = {
      ...{
        type: "css",
      },
      ...options,
    }
    self.handlePromise = self.handlePromise.bind(self)

    return new Promise(self.handlePromise)
  }

  handlePromise(resolve, reject) {
    const self = this
    const { options } = self

    const ids = DependencyResolver.resolve(
      deps(options.moduleName, options.assets),
    )
    // const dependencies = ids.filter((id) => id !== options.moduleName).join(", ")

    new InjectAssets(ids, options.assets, options.type)
      .then(() => {
        // console.log(
        //   `${options.type} - loaded "${options.moduleName}" module${
        //     dependencies ? ` and its dependencies: ${dependencies}` : ""
        //   }.`,
        // )
        resolve()
      })
      .catch(reject)
  }
}
